import { opportunityItemListTransformer } from '@/features/opportunities/helpers';

import { Offer, OfferItemList } from '../types';

import { getColorFromOfferStatus } from './helpers';

export function offerItemListTransformer(offer: Offer): OfferItemList {
  return {
    id: offer.id,
    status: {
      name: offer.status,
      color: getColorFromOfferStatus(offer.status),
    },
    opportunity: opportunityItemListTransformer(offer.opportunity),
    company: offer.company.id,
    createdAt: new Date(offer.created_at),
  };
}
